import React from 'react';

const ustav = `${process.env.PUBLIC_URL}/documents/ustav.doc`;

const About = () => {
    return (
        <section id="about" className="section">
            <div className="container">
                <div className="section-head reveal">
                    <h2 className="section-title">Об <span className="accent">организации</span></h2>
                </div>

                <div className="row g-4 align-items-stretch">
                    <div className="col-lg-7">
                        <div className="card-glass info-card h-100 reveal">
                            <h3 className="card-h">Информация об организации</h3>
                            <dl className="info-list">
                                <div className="info-row">
                                    <dt>Вид деятельности</dt>
                                    <dd>
                                        Деятельность прочих общественных организаций и некоммерческих организаций,
                                        кроме религиозных и политических организаций
                                        <span className="okved">ОКВЭД 94.99</span>
                                    </dd>
                                </div>
                                <div className="info-row">
                                    <dt>Статус организации</dt>
                                    <dd>Некоммерческая, действующая</dd>
                                </div>
                                <div className="info-row">
                                    <dt>Организационно-правовая форма</dt>
                                    <dd>
                                        Общественные организации
                                        <span className="okved">ОКОПФ 20200</span>
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div className="card-glass reg-card h-100 reveal delay-1">
                            <div className="reg-badge">
                                <span className="reg-num">20+</span>
                                <span className="reg-unit">лет</span>
                            </div>
                            <p className="reg-text">
                                РЕГИОНАЛЬНАЯ ОБЩЕСТВЕННАЯ ОРГАНИЗАЦИЯ ИНВАЛИДОВ «ЦЕНТР СЕМЬИ И МОЛОДЕЖИ
                                «СОДЕЙСТВИЕ» зарегистрирована в Едином государственном реестре юридических лиц
                                более 20 лет назад — <b>15 декабря 2004 года</b>.
                            </p>
                            <a className="btn-grad btn-grad--blue" href={ustav} target="_blank" rel="noopener noreferrer">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm0 2.5L17.5 8H14V4.5zM8 13h8v1.5H8V13zm0 3h8v1.5H8V16zm0-6h4v1.5H8V10z"/>
                                </svg>
                                Устав организации
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
